export default __webpack_public_path__ + "static/media/most-popular-icon.434a8bee.png";